import { computed } from 'vue';

import { useDict, useFischer } from '@/composables/fischerPlugin';

export const useSalesforceInformation = () => {
  const fischer = useFischer();
  const dict = useDict();

  const salesforce = fischer.user.getSalesforce();

  const typeDisplay = computed<string>(() => {
    if (salesforce?.salesforceQuoteId) {
      return dict.get('salesforce.Document-Types.Quote');
    }
    if (salesforce?.salesforceOrderId) {
      return dict.get('salesforce.Document-Types.Order');
    }
    return '';
  });

  const erpTypeDisplay = computed<string>(() => {
    const value = salesforce?.cart?.erpOrderType || '';
    if (value === 'ZOA') {
      return dict.get('salesforce.Erp-Types.ZOA') || value;
    }
    return value;
  });

  const deliveryDisplay = computed<string>(() => {
    const value = salesforce?.cart?.completeDelivery;
    return dict.get(value ? 'salesforce.Complete-Delivery' : 'salesforce.Partial-Delivery');
  });

  const opportunityNr = computed<string>(() => {
    return salesforce?.cart?.salesforceOpportunityId || '';
  });

  const designation = computed<string>(() => {
    return salesforce?.cart?.salesforceOpportunityName || '';
  });

  return {
    salesforce,
    typeDisplay,
    deliveryDisplay,
    opportunityNr,
    designation,
    erpTypeDisplay,
  };
};
